import { ActivityIndicator, Text, View } from "react-native";
import { useTranslation } from "react-i18next";

import type { UiTheme } from "../theme";
import { makeTierOneStyles } from "./panelStyles";

// Shared loading / error cards for the Tier-1 panels (lifted from mobile's
// TierOnePanels). `titleKey` is the short panel id (balance/pain/trends);
// the card renders `mobile.progress.<id>.title`.
export function LoadingCard({
  theme,
  titleKey,
}: {
  theme: UiTheme;
  titleKey: string;
}) {
  const { t } = useTranslation();
  const styles = makeTierOneStyles(theme);
  return (
    <View style={styles.card}>
      <Text style={styles.cardTitle}>
        {t(`mobile.progress.${titleKey}.title`, { defaultValue: titleKey })}
      </Text>
      <ActivityIndicator color={theme.palette.brand500} />
    </View>
  );
}

export function ErrorCard({
  theme,
  titleKey,
}: {
  theme: UiTheme;
  titleKey: string;
}) {
  const { t } = useTranslation();
  const styles = makeTierOneStyles(theme);
  return (
    <View style={[styles.card, styles.cardError]}>
      <Text style={styles.cardTitle}>
        {t(`mobile.progress.${titleKey}.title`, { defaultValue: titleKey })}
      </Text>
      <Text style={styles.errorText}>
        {t("mobile.progress.loadFailed", { defaultValue: "Couldn’t load" })}
      </Text>
    </View>
  );
}
